<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: BtnSecondary                                          |
| Section: atoms                                                   |
| Purpose: Secondary navigation button with optional icon support. |
+------------------------------------------------------------------+
-->
<template>
    <a :href="url" :target="target" :rel="linkRel">
        <img v-if="!hideLeftIcon" src="@/assets/icons/arrow-left.svg" alt="">
        {{ label }}
        <i v-if="iconRight" :class="iconRight" aria-hidden="true"></i>
    </a>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        target: {
            type: String,
            default: '_self'
        },
        rel: {
            type: String,
            default: ''
        },
        hideLeftIcon: {
            type: Boolean,
            default: false
        },
        iconRight: {
            type: String,
            default: ''
        }
    },
    computed: {
        linkRel() {
            if (this.rel) return this.rel;
            return this.target === '_blank' ? 'noopener noreferrer' : null;
        }
    }
}
</script>

<style scoped>
a {
    display: inline-flex;
    padding: 12px 24px;
    align-items: center;
    gap: 8px;
    border-radius: var(--border-radius-pill);
    border: 2px solid var(--brand-bg-7);
    background: var(--brand-bg-7);
    color: var(--brand-text-dark);
    font-weight: 600;
    transition: var(--transition-bounce);
    box-shadow: 0px 0px 0px 0px var(--brand-bg-7);
}

a:hover {
    box-shadow: 0px 0px 0px 4px var(--brand-bg-7);
    text-decoration: underline;
}

/* 
a:focus {
    outline-offset: 2px;
    outline: 2px solid var(--brand-bg-7);
} */
</style>